<template>
  <span>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-chip
          v-if="badge"
          :x-small="size === 'x-small'"
          :small="size === 'small'"
          :large="size === 'large'"
          :x-large="size === 'x-large'"
          :color="color"
          dark
          v-bind="tooltip ? attrs : null"
          v-on="tooltip ? on : null"
          :style="clickable ? 'cursor: pointer;' : ''">
          {{ value }}
        </v-chip>
        <span
          v-else-if="block"
          :class="color"
          v-bind="tooltip ? attrs : null"
          v-on="tooltip ? on : null"
          :style="clickable ? 'cursor: pointer; line-height: 24px; padding-left: 4px; padding-right: 4px;' : 'line-height: 24px; padding-left: 4px; padding-right: 4px;'">
          {{ value }}
        </span>
        <span
          v-else
          v-bind="tooltip ? attrs : null"
          v-on="tooltip ? on : null"
          :class="color + '--text'"
          :style="clickable ? 'cursor: pointer;' : ''">
          {{ value }}
        </span>
      </template>
      <span v-html="tooltip"></span>
    </v-tooltip>
  </span>
</template>

<script>
export default {
  name: 'SerpPosition',
  props: ['value', 'color-value', 'badge', 'block', 'size', 'clickable', 'tooltip'],
  computed: {
    color () {
      const value = parseInt(this.colorValue ? this.colorValue : this.value)
      if (value === 1) return 'success'
      if (value === 2) return 'light-green'
      if (value === 3) return 'lime'
      if (value < 10) return 'orange'
      else return 'error'
    },
  }
}
</script>